<template>
  <div class="sign-out">
    
    <div class="header">注销账号</div>
    <div class="content">
      <div class="desc">
        <div class="desc-title">
          请注意当您注销账号后，您将无法通过该账号密码登录上上签。
        </div>
        1、您的账号将无法登录，点击确定后即刻登出；<br/>
        2、绑定的微信账号将与账户解绑，并无法登录上上签；<br/>
        3、您可以通过小程序重新注册上上签账号，账号之间的信息不互通。
      </div>
      <div class="tips">
        <el-checkbox size="mini" v-model="isAgree" class="tips-checkbox"></el-checkbox>
        我已充分知晓注销的后果，并确定要注销
      </div>
    </div>

    <div class="footer">
      <div class="btn" @click="goBack">我再想想</div>
      <div class="btn primary" @click="onSignOutAccount">确认注销</div>
    </div>

    <common-count-down-dialog
      title="注销成功"
      :visible.sync="dialog.showSignOutSuccess"
      :seconds="10"
      @close="gotoHomePage">
      <div class="dialog-body">
        您的账号即将登出！
      </div>
    </common-count-down-dialog>

  </div>
  </template>
  
  <script>
  import Http from '@/libs/http';
  import utils from '@/libs/utils';
  import User from '../../../libs/user';
  import commonCountDownDialog from '../../../components/common/modals/common-count-down-dialog/common-count-down-dialog.vue';

  
  export default {
    components: {
      commonCountDownDialog,
    },
    data() {
      return {
        isAgree: false,
        dialog: {
          showSignOutSuccess: false,
        },
      };
    },
    created() {
    },
    methods: {
      // 返回上一页
      goBack() {
        this.$router.back();
      },
      // 注销账号
      async onSignOutAccount() {

        if (!this.isAgree) {
          utils.msg.warning('请勾选注销账号须知');
          return;
        }


        await utils.msgbox.confirm('账号注销操作不可逆，注销后您可以重新注册上上签，但无法查看历史数据', '确定要注销吗？', {
          confirmButtonText: '　确定　',
          cancelButtonText: ' 取消 ',
          type: 'warning',
        });
        

        Http.post('/peer_account_status_switch', { status: 1 }).then(() => {
          this.dialog.showSignOutSuccess = true;
          // 更改为注销状态，清除定时器请求：因为后端进行数据清除，定时器请求请求到401就返回登录页了
          User.isSignOut = true;
        }).catch((e) => {
          if (e) console.log(e);
        });

      },
      gotoHomePage() {
        // 清除登录信息
        User.logout();
        // this.$router.replace({ name: 'index' });
      },

    },
  };
  </script>
  
<style lang="less" scoped>
.sign-out {
  padding: 24px;
  .header {
    font-weight: 600;
    font-size: 14px;
    color: #2F333D;
    line-height: 14px;
  }
  .content {
    margin-top: 24px;
    
    .desc {
      height: 184px;
      border-radius: 2px;
      border: 1px solid #DEE2E6;
      padding: 20px;
      color: #2F333D;
      font-size: 14px;
      line-height: 24px;
      .desc-title {
        margin-bottom: 8px;
      }
    }
    .tips {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 16px;
      font-size: 14px;
      color: #91999F;
      line-height: 18px;
      .tips-checkbox {
        margin-right: 8px;
        position: relative;
        /deep/ .el-checkbox__inner {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
  .footer{
    display: flex;
    justify-content: center;
    margin-top: 80px;
    .btn{
      padding: 8px 16px;
      border-radius: 2px;
      border: 1px solid #C9CDD1;
      font-size: 14px;
      line-height: 20px;
      color: #2F333D;
      margin-left: 24px;
      cursor: pointer;
      &:first-child {
        margin-left: 0;
      }
      &.primary {
        background: #599FFF;
        border-radius: 2px;
        color: #FFFFFF;
        border: 1px solid #599FFF;
      }
    }
  }
}

.dialog-body{
  text-align: center;
  margin-top: 8px;
  font-size: 18px;
  color: #2F333D;
  line-height: 30px;
  margin-bottom: 40px;
}

</style>
  


// WEBPACK FOOTER //
// src/pages/user/user-children/sign-out.vue